import React from 'react';
import styled from '@emotion/styled';

import { colors } from '@modernhealth/vital-foundation';
import { ComponentTextMedium, pxToRem } from '@modernhealth/vital-components';

const Container = styled.div({
    alignItems: 'center',
    display: 'flex',
});

const Border = styled.div({
    borderBottom: `${pxToRem(1)} solid ${colors.gray05}`,
    width: '100%',
});

const TextContent = styled(ComponentTextMedium)({
    color: colors.gray65,
    paddingLeft: pxToRem(4),
    paddingRight: pxToRem(4),
});

interface Props {
    text: string;
}

export const DividerWithText: React.FC<Props> = ({ text }) => {
    return (
        <Container>
            <Border />
            <TextContent>{text}</TextContent>
            <Border />
        </Container>
    );
};
